<template>
  <div class="e4s-flex-row e4s-gap--standard e4s-subheader--300">
    <template v-if="!isAbnormal">
      <div
        v-for="(trial, key) in trails"
        :key="trial"
        class="e4s-flex-row"
        :class="trial === getHighestScore ? '' : 'e4s-subheader--general'"
      >
      <template v-if="cleanUpScoreValueForDisplay(trial!) !== ''">
        <div v-text="key + ':'" class="trials--key"></div>
        <div v-text="getScoreToDisplay(trial!, isTrack)" class="trials--value"></div>
      </template>
    </div>
    </template>

    <div class="e4s-flex-row e4s-gap--standard-xx" v-if="isAbnormal">
      <div
        v-for="(trial, key) in getTrialsToDisplay"
        :key="trial"
        class="e4s-flex-column trials--abnormal"
      >
        <div v-text="key" class="trials--key e4s-lite-number"></div>
        <div v-text="trial" class="trials--value"></div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import type { AthleteTrialMap } from '@/components/results/store-comp-results'
import { computed, type PropType } from 'vue'
import {
  cleanUpScoreValueForDisplay,
  getHighestScoreFromTrials,
  getScoreToDisplay,
  getTrialsAbnormal
} from '@/components/results/results-service'

defineOptions({
  name: 'RaceTrials'
})

const props = defineProps({
  trails: {
    type: Object as PropType<AthleteTrialMap>,
    required: true
  },
  isTrack: {
    type: Boolean,
    required: false
  }
})

const getHighestScore = computed(() => {
  const highestTrialScore = getHighestScoreFromTrials(props.trails)
  return highestTrialScore
})

const isAbnormal = computed(() => {
  return getTrialsAbnormal(props.trails)
})

const getTrialsToDisplay = computed(() => {
  //return isTrialMapAbnormal(props.trails) ?  : props.trails
  // If abnormal get the last six in the array
  return isAbnormal.value ? getTrialsAbnormal(props.trails) : props.trails
})
</script>

<style scoped>
.trials--abnormal {
  border-left: 1px solid var(--slate-200);
  border-right: 1px solid var(--slate-200);
  padding-left: var(--e4s-gap--small);
  padding-right: var(--e4s-gap--small);
}
.trials--key {
  width: auto;
  white-space: nowrap;
}
.trials--value {
}
</style>
